import ArrowSVG from '@public/icons/arr.svg';
import classNames from 'classnames';
import React from 'react';
import Dropdown from '../Dropdown';

type Props = React.HTMLAttributes<HTMLElement> & {
    id?: string;
    name: string;
    options: { text: string; value: string }[];
    value?: string;
    onChange: (e: React.ChangeEvent<{ name: string; value: string }>) => void;
    onBlur?: (e: React.FocusEvent<HTMLButtonElement>) => void;
    required?: boolean;
    placeholder?: string;
};

function FormSelect({ id, name, options, value, onChange, onBlur, className, required, placeholder }: Props) {
    const handlePick = (selectedValue: string) => {
        onChange({ target: { name, value: selectedValue } } as React.ChangeEvent<{ name: string; value: string }>);
    };

    return (
        <Dropdown className={classNames('form-select', className)}>
            <Dropdown.Toggler
                id={id}
                name={name}
                className={classNames('form-select-btn', { 'not-selected': !value })}
                onBlur={onBlur}
            >
                <div className="text-s form-select-btn-text">
                    {placeholder && !value
                        ? placeholder
                        : options.find((opt) => opt.value === value)?.text || options[0].text}
                </div>
                <ArrowSVG className="form-select-arrow-svg" />
            </Dropdown.Toggler>
            <Dropdown.Content className="form-select__content" position="bottom-left">
                <div className="form-select__content-wrapper">
                    <ul className="list-unstyled form-select__list">
                        {options.map((option) => (
                            <li className="form-select__list-item" key={option.value}>
                                <Dropdown.Picker
                                    className="form-select-item text-xs"
                                    onClick={() => handlePick(option.value)}
                                >
                                    {option.text}
                                </Dropdown.Picker>
                            </li>
                        ))}
                    </ul>
                </div>
            </Dropdown.Content>
        </Dropdown>
    );
}

export default FormSelect;
